import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import { MmAddAttachmentsFormComponent } from '../../../mm-attachments/mm-add-attachments-form/mm-add-attachments-form.component';
import {TranslateService} from '@ngx-translate/core';
import {MediaQueryService} from '@mydocma/core';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {AppContainerService} from "@mydocma/app-container";

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-fault-attachment-dialog',
  templateUrl: './mm-fault-attachment-dialog.component.html',
  styleUrls: ['./mm-fault-attachment-dialog.component.scss']
})
export class MmFaultAttachmentDialogComponent implements OnInit, AfterViewInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<MmFaultAttachmentDialogComponent>,
              private translateService: TranslateService,
              public appContainerService: AppContainerService,
              public readonly mediaQueryService: MediaQueryService) {

  }

  @ViewChild(MmAddAttachmentsFormComponent, {static: false})
  private attachmentForm: MmAddAttachmentsFormComponent;

  canNext = false;

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.attachmentForm.filesChanged$
      .pipe(untilDestroyed(this))
      .subscribe(files => {
        if (files && files.length > 0) {
          this.canNext = true;
        } else {
          this.canNext = false;
        }
      });
  }

  onCancel() {
    this.dialogRef.close();
  }

  next() {
    const result = this.attachmentForm.submit();
    if (result) {
      this.dialogRef.close(result);
      return result;
    }
  }
}
